import BreadCrumb from "@forex/Forex/Breadcrumb";

interface HeroWebV2Props {
  title?: string;
  desc?: string;
  breadcrumb?: Array<{ name: string; link: string }>;
  children?: React.ReactNode;
}

export function HeroWebV2(props: HeroWebV2Props): JSX.Element {
  const { title = "", desc = "", breadcrumb = [], children } = props;

  return (
    <div id="top-banner">
      <div className="top-banner__container">
        <h2 className="top-banner__title">{title}</h2>
        <p className="top-banner__description">{desc}</p>
        <div className="top-banner__breadcrumb">
          <BreadCrumb breadCrumbData={breadcrumb} />
        </div>
      </div>
      {children && <div className="top-banner__wrapper">{children}</div>}
    </div>
  );
}
